import type React from "react";

/* Style dùng chung cho màn Price plans — cùng tông với LegalEntities / PayoutBatches. */

export const cell: React.CSSProperties = {
	padding: "6px 8px",
	borderBottom: "1px solid #eaecf0",
	verticalAlign: "top",
	whiteSpace: "nowrap",
};
export const headCell: React.CSSProperties = {
	...cell,
	background: "#f9fafb",
	color: "#475467",
	fontSize: 12,
	fontWeight: 700,
	textAlign: "left",
	position: "sticky",
	top: 0,
	zIndex: 1,
};
export const num: React.CSSProperties = { textAlign: "right", fontVariantNumeric: "tabular-nums" };
export const mono: React.CSSProperties = { fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace", fontSize: 12 };

export const btn = (primary = false, disabled = false): React.CSSProperties => ({
	padding: "6px 12px",
	borderRadius: 6,
	cursor: disabled ? "not-allowed" : "pointer",
	border: primary ? 0 : "1px solid #d0d5dd",
	background: disabled ? "#e4e7ec" : primary ? "#1570ef" : "#fff",
	color: disabled ? "#98a2b3" : primary ? "#fff" : "#344054",
	fontWeight: 600,
	fontSize: 14,
});

export const input: React.CSSProperties = {
	padding: "6px 10px",
	border: "1px solid #d0d5dd",
	borderRadius: 6,
	fontSize: 14,
	boxSizing: "border-box",
	background: "#fff",
};

export const panel: React.CSSProperties = {
	border: "1px solid #eaecf0",
	borderRadius: 10,
	padding: "14px 16px",
	background: "#fff",
	margin: "0 0 16px",
};

export const panelTitle: React.CSSProperties = { fontWeight: 700, fontSize: 16, margin: "0 0 10px" };

export const muted: React.CSSProperties = { color: "#667085", fontSize: 13 };

export const chip = (bg: string, fg: string): React.CSSProperties => ({
	display: "inline-flex",
	alignItems: "center",
	gap: 6,
	background: bg,
	color: fg,
	borderRadius: 999,
	padding: "3px 12px",
	fontSize: 13,
	fontWeight: 600,
});

export const GROUP_TONE: { [k: string]: { bg: string; fg: string } } = {
	N1: { bg: "#ecfdf3", fg: "#027a48" },
	N2: { bg: "#eff8ff", fg: "#175cd3" },
	N3: { bg: "#fffaeb", fg: "#b54708" },
	N4: { bg: "#fef3f2", fg: "#b42318" },
};

export const tone = {
	ok: "#027a48",
	err: "#b42318",
	warnBg: "#fffaeb",
	warnBorder: "#fedf89",
	warnFg: "#93370d",
	errBg: "#fef3f2",
	errBorder: "#fecdca",
};
